import script from "./maintenance-request-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./maintenance-request-list.vue?vue&type=script&lang=ts&setup=true"

import "./maintenance-request-list.vue?vue&type=style&index=0&id=1e5dbeac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5dbeac"]])

export default __exports__